import { useFeatureFlag } from '#app/hooks/useFeatureFlag.js';
import { dayjs } from '@contra/date';

type MemberSinceLabelProps = {
  createdAt?: null | string;
};

type MemberSinceTooltipProps = {
  firstName?: null | string;
  organizationName?: null | string;
};

const getMemberSinceLabel = ({
  createdAt,
}: MemberSinceLabelProps): null | string => {
  return createdAt ? `MEMBER SINCE ${dayjs(createdAt).format('YYYY')}` : null;
};

const getMemberSinceTooltip = ({
  firstName,
  organizationName,
}: MemberSinceTooltipProps): null | string => {
  return `${organizationName ?? firstName ?? 'This user'} is part of Contra’s exclusive network of clients.`;
};

type Result = {
  memberSinceLabel: null | string;
  memberSinceTooltip: null | string;
};

type UseMembersOnlyBadgeProps = MemberSinceTooltipProps & {
  subscriptionCreatedAt: null | string;
};

export const useMembersOnlyBadge = ({
  firstName,
  organizationName,
  subscriptionCreatedAt,
}: UseMembersOnlyBadgeProps): Result => {
  const membersOnly = useFeatureFlag('membersOnly');

  if (!membersOnly) {
    return {
      memberSinceLabel: null,
      memberSinceTooltip: null,
    };
  }

  const memberSinceLabel = getMemberSinceLabel({
    createdAt: subscriptionCreatedAt,
  });

  const memberSinceTooltip = memberSinceLabel
    ? getMemberSinceTooltip({
        firstName,
        organizationName,
      })
    : null;

  return {
    memberSinceLabel,
    memberSinceTooltip,
  };
};
